import { toErrorKey } from '@instanexus/contracts';
/**
 * The API puts a stable machine code on the wire, never prose (docs/011-i18n.md).
 * This is the only sanctioned way to turn one into something a user reads.
 * An unmapped or unknown code renders `errors:unexpected`, never the raw code.
 */
export function errorMessage(t, code) {
    const fallback = t('errors:unexpected');
    if (typeof code !== 'string' || code.length === 0)
        return fallback;
    return t(`errors:${toErrorKey(code)}`, { defaultValue: fallback });
}
//# sourceMappingURL=error-message.js.map